<template>
  <div v-if="$store.state.currentPlant != null">
  <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
    <b-navbar v-if="getPlantState" toggleable="md" class="second-navbar-style fixed-top navbar-margin">
        <router-link pressed="btn_state_overview" class="nav-link" :to="{path: '/plant/'+ this.$store.state.currentPlant.id}">{{this.$t("navbar.overview")}}</router-link>
        <router-link pressed="btn_state_devices" class="nav-link" :to= "{path: '/plantcentralunits/'+ this.getPathDevices}">{{this.$t("navbar.device")}}</router-link>
        <router-link pressed="btn_state_ambienti" class="nav-link" :to="{path: '/plantlocations/'+ this.$store.state.currentPlant.id}">{{this.$t("navbar.ambienti")}}</router-link>
        <router-link pressed="btn_state_planimetrie" class="nav-link" :to="{path: '/plantmaps/'+ this.$store.state.currentPlant.id}">{{this.$t("navbar.planimetrie")}}</router-link>
        <router-link v-if="this.$store.getters.isCentralized" pressed="btn_state_report" class="nav-link" :to="{path: '/plantreport/'+ this.$store.state.currentPlant.id}">{{this.$t("navbar.report")}}</router-link>
        <router-link v-if="$store.state.showDevFeatures == true" pressed="btn_state_remotepanel" class="nav-link" :to="{path: '/remotepanel/'+ this.$store.state.currentPlant.id}">{{this.$t("navbar.remotepanel")}}</router-link>
        <router-link v-if="this.$store.getters.isCentralized" pressed="btn_state_scenari" class="nav-link" :to="{path: '/scenari/'+ this.$store.state.currentPlant.id}">{{this.$t("navbar.scenari")}}</router-link>
        <router-link v-if="$store.state.showDevFeatures == true" pressed="btn_state_zone" class="nav-link" :to="{path: '/zone/'+ this.getPathZones}">{{this.$t("navbar.zone")}}</router-link>
        <router-link v-if="$store.state.showDevFeatures == true" pressed="btn_state_zone_gest" class="nav-link" :to="{path: '/zone/gestione/'+ this.getPathZones}">{{this.$t("navbar.gestione_zone")}}</router-link>
        <router-link v-if="this.$store.getters.isCentralized" pressed="btn_state_monitoring_zone" class="nav-link" :to="{path: '/monitoringzone/'+ this.$store.state.currentPlant.id}">{{this.$t("navbar.monitoringzone")}}</router-link>
        <router-link v-if="this.$store.getters.isCentralized" pressed="btn_state_bom" class="nav-link" :to="{path: '/plantbom/'+ this.$store.state.currentPlant.id}">{{$t("navbar.bom")}}</router-link>
        <router-link v-else pressed="btn_state_bom" class="nav-link" :to="{path: '/plantbomble/'+ this.$store.state.currentPlant.id}">{{$t("navbar.bom")}}</router-link>
        <!-- <router-link v-if="this.$store.state.currentPlant.technology != 'bluetooth'" pressed="btn_state_bom" class="nav-link" :to="{path: '/plantbom/'+ this.$store.state.currentPlant.id+'/tutti'}">{{$t("navbar.bom")}}</router-link>
        <router-link v-else pressed="btn_state_bom" class="nav-link" :to="{path: '/plantbomble/'+ this.$store.state.currentPlant.id+'/tutti'}">{{$t("navbar.bom")}}</router-link> -->

    </b-navbar>
  </hide-at>
  <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
      <b-row id="bottomNavBar" class="fixed-bottom mx-0 px-0 text-center">
              <b-col cols="2" :class="{active: btn_state_overview}" >
                <router-link :to="{path: '/plant/'+ this.$store.state.currentPlant.id}"><img src="/img/ic_overview.png" /><br/>{{this.$t("navbar.overview")}}</router-link>
              </b-col>
              <b-col cols="2" :class="{active: btn_state_devices}">
                <router-link :to="{path: '/plantcentralunits/'+ this.$store.state.currentPlant.id}"><img src="/img/ic_device.png" /><br/>{{this.$t("navbar.device")}}</router-link>
              </b-col>
              <!-- v-if="this.$store.state.currentPlant.technology!='bluetooth'" -->
              <b-col cols="2" :class="{active: btn_state_maps}">
                <b-dropdown id="altro-dup" dropup right no-caret>
                  <template v-slot:button-content>
                    <img src="img/ic_plant.png" class="mr-1"><br/>{{$t("navbar.schemi")}}
                  </template>
                  <b-dropdown-item :to="{name: 'Ambienti', params: {plantId: this.$store.state.currentPlant.id}}">
                    <b-icon icon="camera" font-scale="2.5" /><br/>{{$t("navbar.ambienti")}}
                  </b-dropdown-item>
                  <b-dropdown-item :to="{name: 'Planimetrie', params: {plantId: this.$store.state.currentPlant.id}}">
                    <b-icon icon="map" font-scale="2.5" /><br/>{{$t("navbar.planimetrie")}}
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>

              <b-col cols="2" :class="{active: btn_state_report}">
                <router-link :to="{path: '/plantreport/'+ this.$store.state.currentPlant.id}"><img src="/img/ic_test.png" /><br/>{{this.$t("navbar.report")}}</router-link>
              </b-col>

              <b-col cols="2" :class="{active: btn_state_scenari}">
                <router-link :to="{path: '/scenari/'+ this.$store.state.currentPlant.id}"><img src="/img/ic_scene.png" /><br/>{{this.$t("navbar.scenari")}}</router-link>
              </b-col>
              <!-- toggle-class="w-100" -->
              <b-col cols="2" :class="{active: btn_more}">
                <b-dropdown id="more-dropdown" dropup right no-caret>
                <template #button-content>
                    <img src="img/ic_menu.png" class="mr-1"><br/> {{$t("navbar.more")}}
                </template>
                  <b-dropdown-item :to="{path: '/monitoringzone/'+ this.$store.state.currentPlant.id}">
                    <b-icon icon="stopwatch" font-scale="2.5" /><br/>{{$t("navbar.monitoringzone")}}
                  </b-dropdown-item>
                  <b-dropdown-item v-if="this.$store.state.currentPlant.technology!='bluetooth'" :to="{path: '/plantbom/'+ this.$store.state.currentPlant.id}">
                    <b-icon icon="card-checklist" font-scale="2.5" /><br/>{{$t("navbar.bom")}}
                  </b-dropdown-item>
                  <b-dropdown-item v-else :to="{path: '/plantbomble/'+ this.$store.state.currentPlant.id}">
                    <b-icon icon="card-checklist" font-scale="2.5" /><br/>{{$t("navbar.bom")}}
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
      </b-row>
  </show-at>
  </div>
</template>

<script>

import {showAt, hideAt} from 'vue-breakpoints'

export default {
  name: 'NavBarMain',
  components: {
    hideAt, showAt
  },
  computed: {
    currentPlant() {
      return this.$store.state.currentPlant;
    },
    getPlantState()
    {
      if(this.$store.state.currentPlant!=null)
        return true
      else
        return false
    },
    getPathDevices()
    {
      var device_path= this.$store.state.currentPlant.id;
      if (this.$router.currentRoute.name == "Emergenza") 
        device_path="emergency/"+this.$store.state.currentPlant.id
      if (this.$router.currentRoute.name == "Illuminazione") 
        device_path="lighting/"+this.$store.state.currentPlant.id
      if (this.$router.currentRoute.name == "Sensori") 
        device_path="sensor/"+this.$store.state.currentPlant.id
      if (this.$router.currentRoute.name == "Aggregazioni") 
        device_path="collection/"+this.$store.state.currentPlant.id
      return device_path
    },
    getPathZones()
    {
      var zone_path= this.$store.state.currentPlant.id;
      //if (this.$router.currentRoute.name == "GestioneZone") 
      //  zone_path="gestione/"+this.$store.state.currentPlant.id
      return zone_path
    },
    //Output: true se la route attuale è \plantbom, \plantbomble o \monitoringZone
    btn_more() {
      if (this.$router.currentRoute.name=="BomImpianto" || this.$router.currentRoute.name=="BomImpiantoBle" || this.$router.currentRoute.name=="MonitoringZone") {
        console.log("btn_more true");
        return true;
      }
      else
        return false;
    },
    btn_state_overview() {
      if(this.$router.currentRoute.name=="HomeImpianto") 
        return true
      else
        return false
    },
    btn_state_devices() {
      if(this.$router.currentRoute.name=="Centrali" || this.$router.currentRoute.name=="Illuminazione") 
        return true
      else
        return false
    },
    btn_state_maps() {
      //  if(this.$router.currentRoute.name=="plantmaps") 
      if (this.$router.currentRoute.name == "Planimetrie" || this.$router.currentRoute.name == "Ambienti")
        return true
      else
        return false
    },
    btn_state_report() {
      if(this.$router.currentRoute.name=="ReportImpianto") 
        return true
      else
        return false
    },
    btn_state_remotepanel() {
      if(this.$router.currentRoute.name=="RemotePanel") 
        return true
      else
        return false
    },
    btn_state_zone() {
      if(this.$router.currentRoute.name=="Zone") 
        return true
      else
        return false
    },
    btn_state_zone_gest() {
      if(this.$router.currentRoute.name=="GestioneZone") 
        return true
      else
        return false
    },
    btn_state_scenari() {
      if(this.$router.currentRoute.name=="Scenari") 
        return true
      else
        return false
    }
 
  },

  watch: {
    currentPlant(newVal, oldVal) {
      console.log("NavBarMain - watch currentPlant: ", newVal);
    } 
  }
}
</script>

<style lang="scss">
    #bottomNavBar {
        min-height: 56px;
        background: linear-gradient(0deg, #007FB4 0%, #009DE0 100%) 0% 0% no-repeat padding-box;
        font-size: 8pt;
        color: #fff;
        

        i {
            font-size: 16px;
        }

        .col-3 {
          padding-bottom: 8px;
          padding-bottom: env(safe-area-inset-bottom);
        }

        a {
          color: #fff;
        }

        @supports(padding: unquote('max(0px)')) {
          .col-3 {
            color: #fff;
            padding-bottom: 8px;
            padding-bottom: unquote('max(8px,env(safe-area-inset-bottom))');
          }
        }

        img {
          width: 26px;
          height: 26px;
          margin-top: 10px;
          margin-bottom: 4px;
        }

        .active {
          background: #009DE0;
        }

        #altro-dup {
          width:100%;
        }

        button {
          display: block;
          background: transparent;
          font-size: 8pt;
          border: none;
          padding: 0px;
          color: #fff;
          padding-right: 10px;
          text-align: center;
          width: 100%;
          margin-right: -10px;
        }

        li {
          border-bottom: 1px solid #ccc;
        }

        li a {
          font-size: 10pt;
          color: #000;
        }

        /* --- STYLES FOR DROPDOWN --- */

        .dropdown-menu {
          /* Set the appearance for the entire dropdown box */
          background: linear-gradient(0deg, #007FB4 0%, #009DE0 100%) 0% 0% no-repeat padding-box;
          padding: 0; /* Remove default padding for a clean look */
          border: none;
        }

        .dropdown-item {
          /* Style the individual items to look like the navbar links */
          color: #fff !important; /* Force white text */
          text-align: center;
          padding: 8px 10px; /* Adjust padding to match your b-col links */
          font-size: 8pt;

          // /* Reset hover background to match the active state */
          // &:hover, &:focus {
          //   background-color: #009DE0 !important;
          // }

          /* Style the images inside the dropdown items */
          img {
            width: 26px;
            height: 26px;
            margin-top: 5px;
            margin-bottom: 2px;
          }

          /* Remove bottom border if you added one */
          // border-bottom: none !important;
        }

        /* Ensure active/current item matches the .active background */
        .dropdown-item.active {
          background: #009DE0 !important;
        }
    }
</style>